import React, { useState ,useEffect} from 'react';
import { 
  Container, 
  Typography, 
  TextField, 
  Button, 
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Box,
  FormControl,
  Select,
  MenuItem,
  Grid,
  Accordion,
  AccordionSummary,
  AccordionDetails,
   Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
  InputLabel
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import CloseIcon from '@mui/icons-material/Close';
import DownloadIcon from '@mui/icons-material/Download';

const PrenatalTest = () => {
  const [opNumber, setOpNumber] = useState('');
  const [patientData, setPatientData] = useState(null);
  const [demographyData, setDemographyData] = useState(null);
   const [loading, setLoading] = useState(false);
      const [saveStatus, setSaveStatus] = useState({ message: '', severity: '' });
      const [openPasswordModal, setOpenPasswordModal] = useState(false);
      const [password, setPassword] = useState('');
      const [downloadFormat, setDownloadFormat] = useState('excel');
  const [showTests, setShowTests] = useState(false);
  const [formData, setFormData] = useState({
    // First Trimester Tests
    urinePregnancyTest: { date: '', result: '', normal: 'Normal', description: '' },
    cbc: { date: '', hb: '', normal: 'Normal', description: '' },
    bloodGroup: { date: '', result: '', normal: 'Normal', description: '' },
    tsh: { date: '', result: '', normal: 'Normal', description: '' },
    bloodSugar: { date: '', result: '', normal: 'Normal', description: '' },
    torch: { date: '', result: '', normal: 'Normal', description: '' },
    hiv: { date: '', result: '', normal: 'Normal', description: '' },
    urineRoutine: { date: '', result: '', normal: 'Normal', description: '' },
    ultrasound: { date: '', ga: '', normal: 'Normal', description: '' },
    ntScan: { date: '', nt: '', normal: 'Normal', description: '' },
    doubleMarker: { date: '', risk: '', normal: 'Normal', description: '' },
    // Second Trimester Tests
    anomalyScan: { date: '', result: '', normal: 'Normal', description: '' },
    ogtt: { date: '', fasting: '', oneHour: '', twoHour: '', normal: 'Normal', description: '' },
    cbcRepeat: { date: '', hb: '', normal: 'Normal', description: '' },
    urineRoutineRepeat: { date: '', result: '', normal: 'Normal', description: '' },
    quadrupleMarker: { date: '', result: '', normal: 'Normal', description: '' },
    fetalEcho: { date: '', result: '', normal: 'Normal', description: '' },
    // Third Trimester Tests
    growthScan: { date: '', ga: '', efw: '', normal: 'Normal', description: '' },
    doppler: { date: '', piRi: '', normal: 'Normal', description: '' },
    cbcFinal: { date: '', hb: '', normal: 'Normal', description: '' },
    bloodSugarFinal: { date: '', result: '', normal: 'Normal', description: '' },
    nst: { date: '', result: '', normal: 'Normal', description: '' },
    lftKft: { date: '', result: '', normal: 'Normal', description: '' },
    presentationScan: { date: '', result: '', normal: 'Normal', description: '' },
  });
    useEffect(() => {
        const data = localStorage.getItem("demography");
        if (data) {
            try {
                const parsedData = JSON.parse(data);
                setDemographyData(parsedData);
            } catch (error) {
                console.error("Error parsing demography data:", error);
            }
        }
    }, []);
  const handleOpNumberChange = (e) => {
    setOpNumber(e.target.value);
  };

  const handleSearch = async () => {
    try {
      // Search for patient in the database
      const response = await fetch(`${process.env.REACT_APP_API_URL}/api/prenatal-tests/search/${opNumber}`);
      
      if (!response.ok) {
        throw new Error("Failed to search for patient");
      }
      
      const patient = await response.json();
      setPatientData(patient);
      setShowTests(true);
      
      // Store in localStorage for future use
      localStorage.setItem("patientData", JSON.stringify(patient));
    } catch (error) {
      console.error("Error:", error);
      setPatientData(null);
      setShowTests(false);
      alert("❌ Patient not found. Please try another IP/OP number.");
    }
  };

  const handleTestChange = (testName, field, value) => {
    setFormData(prev => ({
      ...prev,
      [testName]: {
        ...prev[testName],
        [field]: value,
      },
    }));
  };

  const handleSaveTest = async (testName) => {
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/api/prenatal-tests/save-test`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          patientId: patientData.id,
          testName,
          testData: formData[testName]
        }),
      });

      if (response.ok) {
        alert(`✅ ${testName} data saved successfully!`);
      } else {
        throw new Error('Failed to save test data');
      }
    } catch (error) {
      console.error('Error saving test:', error);
      alert(`❌ Error saving ${testName} data`);
    }
  };

  const handleSubmit = async () => {
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/api/prenatal-tests/submit-all`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          patientId: patientData.id,
          tests: formData
        }),
      });

      if (response.ok) {
        alert('✅ All prenatal test data submitted successfully!');
      } else {
        throw new Error('Failed to submit test data');
      }
    } catch (error) {
      console.error('Error submitting form:', error);
      alert('❌ Error submitting test data');
    }
  };

const handleDownloadConfirm = async () => {
  const correctKey = "Varun@6361";

  // Validate key entered in modal
  if (password !== correctKey) {
    alert("Incorrect key! Download canceled.");
    setPassword('');
    setOpenPasswordModal(false);
    return;
  }

  setOpenPasswordModal(false);
  setLoading(true);
  setSaveStatus({
    message: `Requesting Prenatal Tests ${downloadFormat}...`,
    severity: "info",
  });

  try {
    const resp = await fetch(
      `${process.env.REACT_APP_API_URL}/api/reports/download-form`,
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          table: "prenatal_tests",
          formName: "Prenatal_Tests",
          format: downloadFormat,
          key: password   // 🔥 send KEY instead of password
        }),
      }
    );

    if (!resp.ok) {
      const body = await resp.json().catch(() => ({}));
      setSaveStatus({
        message: `Failed: ${body.message || resp.statusText}`,
        severity: "error",
      });
      return;
    }

    const blob = await resp.blob();
    const disposition = resp.headers.get("content-disposition") || "";

    let filename = `Prenatal_Tests_${Date.now()}.${
      downloadFormat === "excel" ? "xlsx" : "pdf"
    }`;

    const match = /filename="?([^"]+)"?/.exec(disposition);
    if (match && match[1]) filename = match[1];

    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    a.remove();
    window.URL.revokeObjectURL(url);

    setSaveStatus({
      message: `Download started: ${filename}`,
      severity: "success",
    });

  } catch (err) {
    console.error("Download error:", err);
    setSaveStatus({
      message: `Error downloading file: ${err.message}`,
      severity: "error",
    });
  } finally {
    setLoading(false);
    setPassword('');
  }
};

 const handleDownloadClick = () => {
    setOpenPasswordModal(true);
  };
  const handlePasswordModalClose = () => {
    setOpenPasswordModal(false);
    setPassword('');
  };
  return (
    <Box sx={{ padding: 3, backgroundColor: '#f5f7fa', minHeight: '100vh' }}>
      <Container maxWidth="md">
        <Paper
          sx={{
            padding: 3,
            marginBottom: 3,
            borderRadius: '8px',
            boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
            backgroundColor: 'white',
          }}
        >
          <Typography variant="h4" gutterBottom fontWeight="bold" color="secondary" align="center">
            Prenatal Test Form
          </Typography>
          
          <Grid container spacing={2} alignItems="center" sx={{ marginBottom: 2 }}>
            <Grid item xs>
              <TextField
                label="Search by OP Number"
                size="small"
                value={opNumber}
                onChange={handleOpNumberChange}
                fullWidth
              />
            </Grid>
            <Grid item>
              <Button 
                variant="contained" 
                color="primary" 
                onClick={handleSearch}
              >
                Search
              </Button>
            </Grid>
          </Grid>

          {/* Display Patient Information */}
          {patientData && (
            <Paper
              sx={{
                padding: 3,
                marginBottom: 3,
                borderRadius: '8px',
                backgroundColor: '#e3f2fd',
              }}
            >
              <Typography variant="h5" gutterBottom fontWeight="bold" color="secondary">
                Patient Information
              </Typography>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={6}>
                  <Typography><strong>Name:</strong> {patientData.name}</Typography>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Typography><strong>Age:</strong> {patientData.age}</Typography>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Typography><strong>Phone:</strong> {patientData.phone}</Typography>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Typography><strong>IP Number:</strong> {patientData.ip_number}</Typography>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Typography><strong>OP Number:</strong> {patientData.op_number || 'N/A'}</Typography>
                </Grid>
                <Grid item xs={12}>
                  <Typography><strong>Address:</strong> {patientData.address}</Typography>
                </Grid>
              </Grid>
            </Paper>
          )}
   
          {/* Test Section - Only shown after search */}
          {showTests && (
            <>
              <Paper
                sx={{
                  padding: 3,
                  marginBottom: 3,
                  borderRadius: '8px',
                  backgroundColor: '#f9f9f9',
                }}
              >
                <Typography
                  variant="h5"
                  sx={{
                    marginBottom: 2,
                    paddingBottom: 1,
                    borderBottom: '2px solid #3f51b5',
                    color: '#3f51b5',
                  }}
                >
                  Test Results
                </Typography>
  <Box sx={{ position: 'absolute', top: 350, right: 270 }}>
              <Button
                variant="contained"
                color="secondary"
                startIcon={<DownloadIcon />}
                onClick={handleDownloadClick}
                disabled={loading}
                sx={{ 
                  borderRadius: 2,
                  boxShadow: 2,
                  '&:hover': {
                    boxShadow: 4,
                    transform: 'translateY(-2px)',
                    transition: 'all 0.3s ease'
                  }
                }}
              >
                Download 
              </Button>
            </Box>
                {/* First Trimester (0-13 weeks) */}
               <Accordion>
              <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                <Typography>First Trimester (0-13 weeks)</Typography>
              </AccordionSummary>
              <AccordionDetails>
                <TableContainer>
                  <Table size="small">
                    <TableHead>
                      <TableRow>
                        <TableCell>Test</TableCell>
                        <TableCell>Date Done</TableCell>
                        <TableCell>Result</TableCell>
                        <TableCell>Normal/Abnormal</TableCell>
                        <TableCell>Description</TableCell>
                        <TableCell>Action</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      <TableRow>
                        <TableCell>Urine Pregnancy Test</TableCell>
                        <TableCell>
                          <TextField 
                            type="date"
                            size="small"
                            value={formData.urinePregnancyTest.date}
                            onChange={(e) => handleTestChange('urinePregnancyTest', 'date', e.target.value)}
                            InputLabelProps={{ shrink: true }}
                            fullWidth
                          />
                        </TableCell>
                        <TableCell>
                          <TextField 
                            size="small"
                            value={formData.urinePregnancyTest.result}
                            onChange={(e) => handleTestChange('urinePregnancyTest', 'result', e.target.value)}
                            fullWidth
                          />
                        </TableCell>
                        <TableCell>
                          <FormControl fullWidth>
                            <Select
                              size="small"
                              value={formData.urinePregnancyTest.normal}
                              onChange={(e) => handleTestChange('urinePregnancyTest', 'normal', e.target.value)}
                            >
                              <MenuItem value="Normal">Normal</MenuItem>
                              <MenuItem value="Abnormal">Abnormal</MenuItem>
                            </Select>
                          </FormControl>
                        </TableCell>
                        <TableCell>
                          <TextField 
                            size="small"
                            value={formData.urinePregnancyTest.description}
                            onChange={(e) => handleTestChange('urinePregnancyTest', 'description', e.target.value)}
                            fullWidth
                          />
                        </TableCell>
                        <TableCell>
                          <Button 
                            variant="contained" 
                            color="primary" 
                            onClick={() => handleSaveTest('urinePregnancyTest')}
                          >
                            Save
                          </Button>
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell>CBC (Complete Blood Count)</TableCell>
                        <TableCell>
                          <TextField 
                            type="date"
                            size="small"
                            value={formData.cbc.date}
                            onChange={(e) => handleTestChange('cbc', 'date', e.target.value)}
                            InputLabelProps={{ shrink: true }}
                            fullWidth
                          />
                        </TableCell>
                        <TableCell>
                          <TextField 
                            size="small"
                            placeholder="Hb: ___"
                            value={formData.cbc.hb}
                            onChange={(e) => handleTestChange('cbc', 'hb', e.target.value)}
                            fullWidth
                          />
                        </TableCell>
                        <TableCell>
                          <FormControl fullWidth>
                            <Select
                              size="small"
                              value={formData.cbc.normal}
                              onChange={(e) => handleTestChange('cbc', 'normal', e.target.value)}
                            >
                              <MenuItem value="Normal">Normal</MenuItem>
                              <MenuItem value="Abnormal">Abnormal</MenuItem>
                            </Select>
                          </FormControl>
                        </TableCell>
                        <TableCell>
                          <TextField 
                            size="small"
                            value={formData.cbc.description}
                            onChange={(e) => handleTestChange('cbc', 'description', e.target.value)}
                            fullWidth
                          />
                        </TableCell>
                        <TableCell>
                          <Button 
                            variant="contained" 
                            color="primary" 
                            onClick={() => handleSaveTest('cbc')}
                          >
                            Save
                          </Button>
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell>Blood Group & Rh Typing</TableCell>
                        <TableCell>
                          <TextField 
                            type="date"
                            size="small"
                            value={formData.bloodGroup.date}
                            onChange={(e) => handleTestChange('bloodGroup', 'date', e.target.value)}
                            InputLabelProps={{ shrink: true }}
                            fullWidth
                          />
                        </TableCell>
                        <TableCell>
                          <TextField 
                            size="small"
                            value={formData.bloodGroup.result}
                            onChange={(e) => handleTestChange('bloodGroup', 'result', e.target.value)}
                            fullWidth
                          />
                        </TableCell>
                        <TableCell>
                          <FormControl fullWidth>
                            <Select
                              size="small"
                              value={formData.bloodGroup.normal}
                              onChange={(e) => handleTestChange('bloodGroup', 'normal', e.target.value)}
                            >
                              <MenuItem value="Normal">Normal</MenuItem>
                              <MenuItem value="Abnormal">Abnormal</MenuItem>
                            </Select>
                          </FormControl>
                        </TableCell>
                        <TableCell>
                          <TextField 
                            size="small"
                            value={formData.bloodGroup.description}
                            onChange={(e) => handleTestChange('bloodGroup', 'description', e.target.value)}
                            fullWidth
                          />
                        </TableCell>
                        <TableCell>
                          <Button 
                            variant="contained" 
                            color="primary" 
                            onClick={() => handleSaveTest('bloodGroup')}
                          >
                            Save
                          </Button>
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell>TSH (Thyroid Function)</TableCell>
                        <TableCell>
                          <TextField 
                            type="date"
                            size="small"
                            value={formData.tsh.date}
                            onChange={(e) => handleTestChange('tsh', 'date', e.target.value)}
                            InputLabelProps={{ shrink: true }}
                            fullWidth
                          />
                        </TableCell>
                        <TableCell>
                          <TextField 
                            size="small"
                            value={formData.tsh.result}
                            onChange={(e) => handleTestChange('tsh', 'result', e.target.value)}
                            fullWidth
                          />
                        </TableCell>
                        <TableCell>
                          <FormControl fullWidth>
                            <Select
                              size="small"
                              value={formData.tsh.normal}
                              onChange={(e) => handleTestChange('tsh', 'normal', e.target.value)}
                            >
                              <MenuItem value="Normal">Normal</MenuItem>
                              <MenuItem value="Abnormal">Abnormal</MenuItem>
                            </Select>
                          </FormControl>
                        </TableCell>
                        <TableCell>
                          <TextField 
                            size="small"
                            value={formData.tsh.description}
                            onChange={(e) => handleTestChange('tsh', 'description', e.target.value)}
                            fullWidth
                          />
                        </TableCell>
                        <TableCell>
                          <Button 
                            variant="contained" 
                            color="primary" 
                            onClick={() => handleSaveTest('tsh')}
                          >
                            Save
                          </Button>
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell>FBS/RBS (Blood Sugar)</TableCell>
                        <TableCell>
                          <TextField 
                            type="date"
                            size="small"
                            value={formData.bloodSugar.date}
                            onChange={(e) => handleTestChange('bloodSugar', 'date', e.target.value)}
                            InputLabelProps={{ shrink: true }}
                            fullWidth
                          />
                        </TableCell>
                        <TableCell>
                          <TextField 
                            size="small"
                            value={formData.bloodSugar.result}
                            onChange={(e) => handleTestChange('bloodSugar', 'result', e.target.value)}
                            fullWidth
                          />
                        </TableCell>
                        <TableCell>
                          <FormControl fullWidth>
                            <Select
                              size="small"
                              value={formData.bloodSugar.normal}
                              onChange={(e) => handleTestChange('bloodSugar', 'normal', e.target.value)}
                            >
                              <MenuItem value="Normal">Normal</MenuItem>
                              <MenuItem value="Abnormal">Abnormal</MenuItem>
                            </Select>
                          </FormControl>
                        </TableCell>
                        <TableCell>
                          <TextField 
                            size="small"
                            value={formData.bloodSugar.description}
                            onChange={(e) => handleTestChange('bloodSugar', 'description', e.target.value)}
                            fullWidth
                          />
                        </TableCell>
                        <TableCell>
                          <Button 
                            variant="contained" 
                            color="primary" 
                            onClick={() => handleSaveTest('bloodSugar')}
                          >
                            Save
                          </Button>
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell>TORCH Panel</TableCell>
                        <TableCell>
                          <TextField 
                            type="date"
                            size="small"
                            value={formData.torch.date}
                            onChange={(e) => handleTestChange('torch', 'date', e.target.value)}
                            InputLabelProps={{ shrink: true }}
                            fullWidth
                          />
                        </TableCell>
                        <TableCell>
                          <TextField 
                            size="small"
                            value={formData.torch.result}
                            onChange={(e) => handleTestChange('torch', 'result', e.target.value)}
                            fullWidth
                          />
                        </TableCell>
                        <TableCell>
                          <FormControl fullWidth>
                            <Select
                              size="small"
                              value={formData.torch.normal}
                              onChange={(e) => handleTestChange('torch', 'normal', e.target.value)}
                            >
                              <MenuItem value="Normal">Normal</MenuItem>
                              <MenuItem value="Abnormal">Abnormal</MenuItem>
                            </Select>
                          </FormControl>
                        </TableCell>
                        <TableCell>
                          <TextField 
                            size="small"
                            value={formData.torch.description}
                            onChange={(e) => handleTestChange('torch', 'description', e.target.value)}
                            fullWidth
                          />
                        </TableCell>
                        <TableCell>
                          <Button 
                            variant="contained" 
                            color="primary" 
                            onClick={() => handleSaveTest('torch')}
                          >
                            Save
                          </Button>
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell>HIV, HBsAg, VDRL</TableCell>
                        <TableCell>
                          <TextField 
                            type="date"
                            size="small"
                            value={formData.hiv.date}
                            onChange={(e) => handleTestChange('hiv', 'date', e.target.value)}
                            InputLabelProps={{ shrink: true }}
                            fullWidth
                          />
                        </TableCell>
                        <TableCell>
                          <TextField 
                            size="small"
                            value={formData.hiv.result}
                            onChange={(e) => handleTestChange('hiv', 'result', e.target.value)}
                            fullWidth
                          />
                        </TableCell>
                        <TableCell>
                          <FormControl fullWidth>
                            <Select
                              size="small"
                              value={formData.hiv.normal}
                              onChange={(e) => handleTestChange('hiv', 'normal', e.target.value)}
                            >
                              <MenuItem value="Normal">Normal</MenuItem>
                              <MenuItem value="Abnormal">Abnormal</MenuItem>
                            </Select>
                          </FormControl>
                        </TableCell>
                        <TableCell>
                          <TextField 
                            size="small"
                            value={formData.hiv.description}
                            onChange={(e) => handleTestChange('hiv', 'description', e.target.value)}
                            fullWidth
                          />
                        </TableCell>
                        <TableCell>
                          <Button 
                            variant="contained" 
                            color="primary" 
                            onClick={() => handleSaveTest('hiv')}
                          >
                            Save
                          </Button>
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell>Urine Routine/Microscopy</TableCell>
                        <TableCell>
                          <TextField 
                            type="date"
                            size="small"
                            value={formData.urineRoutine.date}
                            onChange={(e) => handleTestChange('urineRoutine', 'date', e.target.value)}
                            InputLabelProps={{ shrink: true }}
                            fullWidth
                          />
                        </TableCell>
                        <TableCell>
                          <TextField 
                            size="small"
                            value={formData.urineRoutine.result}
                            onChange={(e) => handleTestChange('urineRoutine', 'result', e.target.value)}
                            fullWidth
                          />
                        </TableCell>
                        <TableCell>
                          <FormControl fullWidth>
                            <Select
                              size="small"
                              value={formData.urineRoutine.normal}
                              onChange={(e) => handleTestChange('urineRoutine', 'normal', e.target.value)}
                            >
                              <MenuItem value="Normal">Normal</MenuItem>
                              <MenuItem value="Abnormal">Abnormal</MenuItem>
                            </Select>
                          </FormControl>
                        </TableCell>
                        <TableCell>
                          <TextField 
                            size="small"
                            value={formData.urineRoutine.description}
                            onChange={(e) => handleTestChange('urineRoutine', 'description', e.target.value)}
                            fullWidth
                          />
                        </TableCell>
                        <TableCell>
                          <Button 
                            variant="contained" 
                            color="primary" 
                            onClick={() => handleSaveTest('urineRoutine')}
                          >
                            Save
                          </Button>
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell>Ultrasound – Dating Scan</TableCell>
                        <TableCell>
                          <TextField 
                            type="date"
                            size="small"
                            value={formData.ultrasound.date}
                            onChange={(e) => handleTestChange('ultrasound', 'date', e.target.value)}
                            InputLabelProps={{ shrink: true }}
                            fullWidth
                          />
                        </TableCell>
                        <TableCell>
                          <TextField 
                            size="small"
                            placeholder="GA: ___"
                            value={formData.ultrasound.ga}
                            onChange={(e) => handleTestChange('ultrasound', 'ga', e.target.value)}
                            fullWidth
                          />
                        </TableCell>
                        <TableCell>
                          <FormControl fullWidth>
                            <Select
                              size="small"
                              value={formData.ultrasound.normal}
                              onChange={(e) => handleTestChange('ultrasound', 'normal', e.target.value)}
                            >
                              <MenuItem value="Normal">Normal</MenuItem>
                              <MenuItem value="Abnormal">Abnormal</MenuItem>
                            </Select>
                          </FormControl>
                        </TableCell>
                        <TableCell>
                          <TextField 
                            size="small"
                            value={formData.ultrasound.description}
                            onChange={(e) => handleTestChange('ultrasound', 'description', e.target.value)}
                            fullWidth
                          />
                        </TableCell>
                        <TableCell>
                          <Button 
                            variant="contained" 
                            color="primary" 
                            onClick={() => handleSaveTest('ultrasound')}
                          >
                            Save
                          </Button>
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell>NT Scan</TableCell>
                        <TableCell>
                          <TextField 
                            type="date"
                            size="small"
                            value={formData.ntScan.date}
                            onChange={(e) => handleTestChange('ntScan', 'date', e.target.value)}
                            InputLabelProps={{ shrink: true }}
                            fullWidth
                          />
                        </TableCell>
                        <TableCell>
                          <TextField 
                            size="small"
                            placeholder="NT: ___ mm"
                            value={formData.ntScan.nt}
                            onChange={(e) => handleTestChange('ntScan', 'nt', e.target.value)}
                            fullWidth
                          />
                        </TableCell>
                        <TableCell>
                          <FormControl fullWidth>
                            <Select
                              size="small"
                              value={formData.ntScan.normal}
                              onChange={(e) => handleTestChange('ntScan', 'normal', e.target.value)}
                            >
                              <MenuItem value="Normal">Normal</MenuItem>
                              <MenuItem value="Abnormal">Abnormal</MenuItem>
                            </Select>
                          </FormControl>
                        </TableCell>
                        <TableCell>
                          <TextField 
                            size="small"
                            value={formData.ntScan.description}
                            onChange={(e) => handleTestChange('ntScan', 'description', e.target.value)}
                            fullWidth
                          />
                        </TableCell>
                        <TableCell>
                          <Button 
                            variant="contained" 
                            color="primary" 
                            onClick={() => handleSaveTest('ntScan')}
                          >
                            Save
                          </Button>
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell>Double Marker (optional)</TableCell>
                        <TableCell>
                          <TextField 
                            type="date"
                            size="small"
                            value={formData.doubleMarker.date}
                            onChange={(e) => handleTestChange('doubleMarker', 'date', e.target.value)}
                            InputLabelProps={{ shrink: true }}
                            fullWidth
                          />
                        </TableCell>
                        <TableCell>
                          <TextField 
                            size="small"
                            placeholder="Risk: ___"
                            value={formData.doubleMarker.risk}
                            onChange={(e) => handleTestChange('doubleMarker', 'risk', e.target.value)}
                            fullWidth
                          />
                        </TableCell>
                        <TableCell>
                          <FormControl fullWidth>
                            <Select
                              size="small"
                              value={formData.doubleMarker.normal}
                              onChange={(e) => handleTestChange('doubleMarker', 'normal', e.target.value)}
                            >
                              <MenuItem value="Normal">Normal</MenuItem>
                              <MenuItem value="Abnormal">Abnormal</MenuItem>
                            </Select>
                          </FormControl>
                        </TableCell>
                        <TableCell>
                          <TextField 
                            size="small"
                            value={formData.doubleMarker.description}
                            onChange={(e) => handleTestChange('doubleMarker', 'description', e.target.value)}
                            fullWidth
                          />
                        </TableCell>
                        <TableCell>
                          <Button 
                            variant="contained" 
                            color="primary" 
                            onClick={() => handleSaveTest('doubleMarker')}
                          >
                            Save
                          </Button>
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  </Table>
                </TableContainer>
              </AccordionDetails>
            </Accordion>

            {/* Second Trimester (14-27 weeks) */}
            <Accordion>
              <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                <Typography>Second Trimester (14-27 weeks)</Typography>
              </AccordionSummary>
              <AccordionDetails>
                <TableContainer>
                  <Table size="small">
                    <TableHead>
                      <TableRow>
                        <TableCell>Test</TableCell>
                        <TableCell>Date Done</TableCell>
                        <TableCell>Result</TableCell>
                        <TableCell>Normal/Abnormal</TableCell>
                        <TableCell>Description</TableCell>
                        <TableCell>Action</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      <TableRow>
                        <TableCell>Anomaly Scan</TableCell>
                        <TableCell>
                          <TextField 
                            type="date"
                            size="small"
                            value={formData.anomalyScan.date}
                            onChange={(e) => handleTestChange('anomalyScan', 'date', e.target.value)}
                            InputLabelProps={{ shrink: true }}
                            fullWidth
                          />
                        </TableCell>
                        <TableCell>
                          <TextField 
                            size="small"
                            value={formData.anomalyScan.result}
                            onChange={(e) => handleTestChange('anomalyScan', 'result', e.target.value)}
                            fullWidth
                          />
                        </TableCell>
                        <TableCell>
                          <FormControl fullWidth>
                            <Select
                              size="small"
                              value={formData.anomalyScan.normal}
                              onChange={(e) => handleTestChange('anomalyScan', 'normal', e.target.value)}
                            >
                              <MenuItem value="Normal">Normal</MenuItem>
                              <MenuItem value="Abnormal">Abnormal</MenuItem>
                            </Select>
                          </FormControl>
                        </TableCell>
                        <TableCell>
                          <TextField 
                            size="small"
                            value={formData.anomalyScan.description}
                            onChange={(e) => handleTestChange('anomalyScan', 'description', e.target.value)}
                            fullWidth
                          />
                        </TableCell>
                        <TableCell>
                          <Button 
                            variant="contained" 
                            color="primary" 
                            onClick={() => handleSaveTest('anomalyScan')}
                          >
                            Save
                          </Button>
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell>OGTT (75g – Glucose Tolerance Test)</TableCell>
                        <TableCell>
                          <TextField 
                            type="date"
                            size="small"
                            value={formData.ogtt.date}
                            onChange={(e) => handleTestChange('ogtt', 'date', e.target.value)}
                            InputLabelProps={{ shrink: true }}
                            fullWidth
                          />
                        </TableCell>
                        <TableCell>
                          <Grid container spacing={1}>
                            <Grid item xs={4}>
                              <TextField 
                                size="small"
                                placeholder="Fasting: ___"
                                value={formData.ogtt.fasting}
                                onChange={(e) => handleTestChange('ogtt', 'fasting', e.target.value)}
                                fullWidth
                              />
                            </Grid>
                            <Grid item xs={4}>
                              <TextField 
                                size="small"
                                placeholder="1 hr: ___"
                                value={formData.ogtt.oneHour}
                                onChange={(e) => handleTestChange('ogtt', 'oneHour', e.target.value)}
                                fullWidth
                              />
                            </Grid>
                            <Grid item xs={4}>
                              <TextField 
                                size="small"
                                placeholder="2 hr: ___"
                                value={formData.ogtt.twoHour}
                                onChange={(e) => handleTestChange('ogtt', 'twoHour', e.target.value)}
                                fullWidth
                              />
                            </Grid>
                          </Grid>
                        </TableCell>
                        <TableCell>
                          <FormControl fullWidth>
                            <Select
                              size="small"
                              value={formData.ogtt.normal}
                              onChange={(e) => handleTestChange('ogtt', 'normal', e.target.value)}
                            >
                              <MenuItem value="Normal">Normal</MenuItem>
                              <MenuItem value="Abnormal">Abnormal</MenuItem>
                            </Select>
                          </FormControl>
                        </TableCell>
                        <TableCell>
                          <TextField 
                            size="small"
                            value={formData.ogtt.description}
                            onChange={(e) => handleTestChange('ogtt', 'description', e.target.value)}
                            fullWidth
                          />
                        </TableCell>
                        <TableCell>
                          <Button 
                            variant="contained" 
                            color="primary" 
                            onClick={() => handleSaveTest('ogtt')}
                          >
                            Save
                          </Button>
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell>CBC (Repeat)</TableCell>
                        <TableCell>
                          <TextField 
                            type="date"
                            size="small"
                            value={formData.cbcRepeat.date}
                            onChange={(e) => handleTestChange('cbcRepeat', 'date', e.target.value)}
                            InputLabelProps={{ shrink: true }}
                            fullWidth
                          />
                        </TableCell>
                        <TableCell>
                          <TextField 
                            size="small"
                            placeholder="Hb: ___"
                            value={formData.cbcRepeat.hb}
                            onChange={(e) => handleTestChange('cbcRepeat', 'hb', e.target.value)}
                            fullWidth
                          />
                        </TableCell>
                        <TableCell>
                          <FormControl fullWidth>
                            <Select
                              size="small"
                              value={formData.cbcRepeat.normal}
                              onChange={(e) => handleTestChange('cbcRepeat', 'normal', e.target.value)}
                            >
                              <MenuItem value="Normal">Normal</MenuItem>
                              <MenuItem value="Abnormal">Abnormal</MenuItem>
                            </Select>
                          </FormControl>
                        </TableCell>
                        <TableCell>
                          <TextField 
                            size="small"
                            value={formData.cbcRepeat.description}
                            onChange={(e) => handleTestChange('cbcRepeat', 'description', e.target.value)}
                            fullWidth
                          />
                        </TableCell>
                        <TableCell>
                          <Button 
                            variant="contained" 
                            color="primary" 
                            onClick={() => handleSaveTest('cbcRepeat')}
                          >
                            Save
                          </Button>
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell>Urine Routine</TableCell>
                        <TableCell>
                          <TextField 
                            type="date"
                            size="small"
                            value={formData.urineRoutineRepeat.date}
                            onChange={(e) => handleTestChange('urineRoutineRepeat', 'date', e.target.value)}
                            InputLabelProps={{ shrink: true }}
                            fullWidth
                          />
                        </TableCell>
                        <TableCell>
                          <TextField 
                            size="small"
                            value={formData.urineRoutineRepeat.result}
                            onChange={(e) => handleTestChange('urineRoutineRepeat', 'result', e.target.value)}
                            fullWidth
                          />
                        </TableCell>
                        <TableCell>
                          <FormControl fullWidth>
                            <Select
                              size="small"
                              value={formData.urineRoutineRepeat.normal}
                              onChange={(e) => handleTestChange('urineRoutineRepeat', 'normal', e.target.value)}
                            >
                              <MenuItem value="Normal">Normal</MenuItem>
                              <MenuItem value="Abnormal">Abnormal</MenuItem>
                            </Select>
                          </FormControl>
                        </TableCell>
                        <TableCell>
                          <TextField 
                            size="small"
                            value={formData.urineRoutineRepeat.description}
                            onChange={(e) => handleTestChange('urineRoutineRepeat', 'description', e.target.value)}
                            fullWidth
                          />
                        </TableCell>
                        <TableCell>
                          <Button 
                            variant="contained" 
                            color="primary" 
                            onClick={() => handleSaveTest('urineRoutineRepeat')}
                          >
                            Save
                          </Button>
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell>Quadruple Marker (if indicated)</TableCell>
                        <TableCell>
                          <TextField 
                            type="date"
                            size="small"
                            value={formData.quadrupleMarker.date}
                            onChange={(e) => handleTestChange('quadrupleMarker', 'date', e.target.value)}
                            InputLabelProps={{ shrink: true }}
                            fullWidth
                          />
                        </TableCell>
                        <TableCell>
                          <TextField 
                            size="small"
                            value={formData.quadrupleMarker.result}
                            onChange={(e) => handleTestChange('quadrupleMarker', 'result', e.target.value)}
                            fullWidth
                          />
                        </TableCell>
                        <TableCell>
                          <FormControl fullWidth>
                            <Select
                              size="small"
                              value={formData.quadrupleMarker.normal}
                              onChange={(e) => handleTestChange('quadrupleMarker', 'normal', e.target.value)}
                            >
                              <MenuItem value="Normal">Normal</MenuItem>
                              <MenuItem value="Abnormal">Abnormal</MenuItem>
                            </Select>
                          </FormControl>
                        </TableCell>
                        <TableCell>
                          <TextField 
                            size="small"
                            value={formData.quadrupleMarker.description}
                            onChange={(e) => handleTestChange('quadrupleMarker', 'description', e.target.value)}
                            fullWidth
                          />
                        </TableCell>
                        <TableCell>
                          <Button 
                            variant="contained" 
                            color="primary" 
                            onClick={() => handleSaveTest('quadrupleMarker')}
                          >
                            Save
                          </Button>
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell>Fetal Echocardiography (if indicated)</TableCell>
                        <TableCell>
                          <TextField 
                            type="date"
                            size="small"
                            value={formData.fetalEcho.date}
                            onChange={(e) => handleTestChange('fetalEcho', 'date', e.target.value)}
                            InputLabelProps={{ shrink: true }}
                            fullWidth
                          />
                        </TableCell>
                        <TableCell>
                          <TextField 
                            size="small"
                            value={formData.fetalEcho.result}
                            onChange={(e) => handleTestChange('fetalEcho', 'result', e.target.value)}
                            fullWidth
                          />
                        </TableCell>
                        <TableCell>
                          <FormControl fullWidth>
                            <Select
                              size="small"
                              value={formData.fetalEcho.normal}
                              onChange={(e) => handleTestChange('fetalEcho', 'normal', e.target.value)}
                            >
                              <MenuItem value="Normal">Normal</MenuItem>
                              <MenuItem value="Abnormal">Abnormal</MenuItem>
                            </Select>
                          </FormControl>
                        </TableCell>
                        <TableCell>
                          <TextField 
                            size="small"
                            value={formData.fetalEcho.description}
                            onChange={(e) => handleTestChange('fetalEcho', 'description', e.target.value)}
                            fullWidth
                          />
                        </TableCell>
                        <TableCell>
                          <Button 
                            variant="contained" 
                            color="primary" 
                            onClick={() => handleSaveTest('fetalEcho')}
                          >
                            Save
                          </Button>
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  </Table>
                </TableContainer>
              </AccordionDetails>
            </Accordion>

            {/* Third Trimester (28-40 weeks) */}
            <Accordion>
              <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                <Typography>Third Trimester (28-40 weeks)</Typography>
              </AccordionSummary>
              <AccordionDetails>
                <TableContainer>
                  <Table size="small">
                    <TableHead>
                      <TableRow>
                        <TableCell>Test</TableCell>
                        <TableCell>Date Done</TableCell>
                        <TableCell>Result</TableCell>
                        <TableCell>Normal/Abnormal</TableCell>
                        <TableCell>Description</TableCell>
                        <TableCell>Action</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      <TableRow>
                        <TableCell>Growth Scan</TableCell>
                        <TableCell>
                          <TextField 
                            type="date"
                            size="small"
                            value={formData.growthScan.date}
                            onChange={(e) => handleTestChange('growthScan', 'date', e.target.value)}
                            InputLabelProps={{ shrink: true }}
                            fullWidth
                          />
                        </TableCell>
                        <TableCell>
                          <TextField 
                            size="small"
                            placeholder="GA: ___, EFW: ___"
                            value={formData.growthScan.ga + ', EFW: ' + formData.growthScan.efw}
                            onChange={(e) => {
                              const [ga, efw] = e.target.value.split(', EFW: ');
                              handleTestChange('growthScan', 'ga', ga);
                              handleTestChange('growthScan', 'efw', efw || '');
                            }}
                            fullWidth
                          />
                        </TableCell>
                        <TableCell>
                          <FormControl fullWidth>
                            <Select
                              size="small"
                              value={formData.growthScan.normal}
                              onChange={(e) => handleTestChange('growthScan', 'normal', e.target.value)}
                            >
                              <MenuItem value="Normal">Normal</MenuItem>
                              <MenuItem value="Abnormal">Abnormal</MenuItem>
                            </Select>
                          </FormControl>
                        </TableCell>
                        <TableCell>
                          <TextField 
                            size="small"
                            value={formData.growthScan.description}
                            onChange={(e) => handleTestChange('growthScan', 'description', e.target.value)}
                            fullWidth
                          />
                        </TableCell>
                        <TableCell>
                          <Button 
                            variant="contained" 
                            color="primary" 
                            onClick={() => handleSaveTest('growthScan')}
                          >
                            Save
                          </Button>
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell>Doppler (if indicated)</TableCell>
                        <TableCell>
                          <TextField 
                            type="date"
                            size="small"
                            value={formData.doppler.date}
                            onChange={(e) => handleTestChange('doppler', 'date', e.target.value)}
                            InputLabelProps={{ shrink: true }}
                            fullWidth
                          />
                        </TableCell>
                        <TableCell>
                          <TextField 
                            size="small"
                            placeholder="PI/RI: ___"
                            value={formData.doppler.piRi}
                            onChange={(e) => handleTestChange('doppler', 'piRi', e.target.value)}
                            fullWidth
                          />
                        </TableCell>
                        <TableCell>
                          <FormControl fullWidth>
                            <Select
                              size="small"
                              value={formData.doppler.normal}
                              onChange={(e) => handleTestChange('doppler', 'normal', e.target.value)}
                            >
                              <MenuItem value="Normal">Normal</MenuItem>
                              <MenuItem value="Abnormal">Abnormal</MenuItem>
                            </Select>
                          </FormControl>
                        </TableCell>
                        <TableCell>
                          <TextField 
                            size="small"
                            value={formData.doppler.description}
                            onChange={(e) => handleTestChange('doppler', 'description', e.target.value)}
                            fullWidth
                          />
                        </TableCell>
                        <TableCell>
                          <Button 
                            variant="contained" 
                            color="primary" 
                            onClick={() => handleSaveTest('doppler')}
                          >
                            Save
                          </Button>
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell>CBC (Final Trimester)</TableCell>
                        <TableCell>
                          <TextField 
                            type="date"
                            size="small"
                            value={formData.cbcFinal.date}
                            onChange={(e) => handleTestChange('cbcFinal', 'date', e.target.value)}
                            InputLabelProps={{ shrink: true }}
                            fullWidth
                          />
                        </TableCell>
                        <TableCell>
                          <TextField 
                            size="small"
                            placeholder="Hb: ___"
                            value={formData.cbcFinal.hb}
                            onChange={(e) => handleTestChange('cbcFinal', 'hb', e.target.value)}
                            fullWidth
                          />
                        </TableCell>
                        <TableCell>
                          <FormControl fullWidth>
                            <Select
                              size="small"
                              value={formData.cbcFinal.normal}
                              onChange={(e) => handleTestChange('cbcFinal', 'normal', e.target.value)}
                            >
                              <MenuItem value="Normal">Normal</MenuItem>
                              <MenuItem value="Abnormal">Abnormal</MenuItem>
                            </Select>
                          </FormControl>
                        </TableCell>
                        <TableCell>
                          <TextField 
                            size="small"
                            value={formData.cbcFinal.description}
                            onChange={(e) => handleTestChange('cbcFinal', 'description', e.target.value)}
                            fullWidth
                          />
                        </TableCell>
                        <TableCell>
                          <Button 
                            variant="contained" 
                            color="primary" 
                            onClick={() => handleSaveTest('cbcFinal')}
                          >
                            Save
                          </Button>
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell>Blood Sugar (FBS/PPBS)</TableCell>
                        <TableCell>
                          <TextField 
                            type="date"
                            size="small"
                            value={formData.bloodSugarFinal.date}
                            onChange={(e) => handleTestChange('bloodSugarFinal', 'date', e.target.value)}
                            InputLabelProps={{ shrink: true }}
                            fullWidth
                          />
                        </TableCell>
                        <TableCell>
                          <TextField 
                            size="small"
                            value={formData.bloodSugarFinal.result}
                            onChange={(e) => handleTestChange('bloodSugarFinal', 'result', e.target.value)}
                            fullWidth
                          />
                        </TableCell>
                        <TableCell>
                          <FormControl fullWidth>
                            <Select
                              size="small"
                              value={formData.bloodSugarFinal.normal}
                              onChange={(e) => handleTestChange('bloodSugarFinal', 'normal', e.target.value)}
                            >
                              <MenuItem value="Normal">Normal</MenuItem>
                              <MenuItem value="Abnormal">Abnormal</MenuItem>
                            </Select>
                          </FormControl>
                        </TableCell>
                        <TableCell>
                          <TextField 
                            size="small"
                            value={formData.bloodSugarFinal.description}
                            onChange={(e) => handleTestChange('bloodSugarFinal', 'description', e.target.value)}
                            fullWidth
                          />
                        </TableCell>
                        <TableCell>
                          <Button 
                            variant="contained" 
                            color="primary" 
                            onClick={() => handleSaveTest('bloodSugarFinal')}
                          >
                            Save
                          </Button>
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell>NST (Non-Stress Test)</TableCell>
                        <TableCell>
                          <TextField 
                            type="date"
                            size="small"
                            value={formData.nst.date}
                            onChange={(e) => handleTestChange('nst', 'date', e.target.value)}
                            InputLabelProps={{ shrink: true }}
                            fullWidth
                          />
                        </TableCell>
                        <TableCell>
                          <TextField 
                            size="small"
                            placeholder="Reactive / Non-Reactive"
                            value={formData.nst.result}
                            onChange={(e) => handleTestChange('nst', 'result', e.target.value)}
                            fullWidth
                          />
                        </TableCell>
                        <TableCell>
                          <FormControl fullWidth>
                            <Select
                              size="small"
                              value={formData.nst.normal}
                              onChange={(e) => handleTestChange('nst', 'normal', e.target.value)}
                            >
                              <MenuItem value="Normal">Normal</MenuItem>
                              <MenuItem value="Abnormal">Abnormal</MenuItem>
                            </Select>
                          </FormControl>
                        </TableCell>
                        <TableCell>
                          <TextField 
                            size="small"
                            value={formData.nst.description}
                            onChange={(e) => handleTestChange('nst', 'description', e.target.value)}
                            fullWidth
                          />
                        </TableCell>
                        <TableCell>
                          <Button 
                            variant="contained" 
                            color="primary" 
                            onClick={() => handleSaveTest('nst')}
                          >
                            Save
                          </Button>
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell>LFT / KFT (if high risk)</TableCell>
                        <TableCell>
                          <TextField 
                            type="date"
                            size="small"
                            value={formData.lftKft.date}
                            onChange={(e) => handleTestChange('lftKft', 'date', e.target.value)}
                            InputLabelProps={{ shrink: true }}
                            fullWidth
                          />
                        </TableCell>
                        <TableCell>
                          <TextField 
                            size="small"
                            value={formData.lftKft.result}
                            onChange={(e) => handleTestChange('lftKft', 'result', e.target.value)}
                            fullWidth
                          />
                        </TableCell>
                        <TableCell>
                          <FormControl fullWidth>
                            <Select
                              size="small"
                              value={formData.lftKft.normal}
                              onChange={(e) => handleTestChange('lftKft', 'normal', e.target.value)}
                            >
                              <MenuItem value="Normal">Normal</MenuItem>
                              <MenuItem value="Abnormal">Abnormal</MenuItem>
                            </Select>
                          </FormControl>
                        </TableCell>
                        <TableCell>
                          <TextField 
                            size="small"
                            value={formData.lftKft.description}
                            onChange={(e) => handleTestChange('lftKft', 'description', e.target.value)}
                            fullWidth
                          />
                        </TableCell>
                        <TableCell>
                          <Button 
                            variant="contained" 
                            color="primary" 
                            onClick={() => handleSaveTest('lftKft')}
                          >
                            Save
                          </Button>
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell>Presentation Scan</TableCell>
                        <TableCell>
                          <TextField 
                            type="date"
                            size="small"
                            value={formData.presentationScan.date}
                            onChange={(e) => handleTestChange('presentationScan', 'date', e.target.value)}
                            InputLabelProps={{ shrink: true }}
                            fullWidth
                          />
                        </TableCell>
                        <TableCell>
                          <TextField 
                            size="small"
                            placeholder="Cephalic/Breech/Other"
                            value={formData.presentationScan.result}
                            onChange={(e) => handleTestChange('presentationScan', 'result', e.target.value)}
                            fullWidth
                          />
                        </TableCell>
                        <TableCell>
                          <FormControl fullWidth>
                            <Select
                              size="small"
                              value={formData.presentationScan.normal}
                              onChange={(e) => handleTestChange('presentationScan', 'normal', e.target.value)}
                            >
                              <MenuItem value="Normal">Normal</MenuItem>
                              <MenuItem value="Abnormal">Abnormal</MenuItem>
                            </Select>
                          </FormControl>
                        </TableCell>
                        <TableCell>
                          <TextField 
                            size="small"
                            value={formData.presentationScan.description}
                            onChange={(e) => handleTestChange('presentationScan', 'description', e.target.value)}
                            fullWidth
                          />
                        </TableCell>
                        <TableCell>
                          <Button 
                            variant="contained" 
                            color="primary" 
                            onClick={() => handleSaveTest('presentationScan')}
                          >
                            Save
                          </Button>
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  </Table>
                </TableContainer>
              </AccordionDetails>
            </Accordion>
              </Paper>
                   <Dialog 
        open={openPasswordModal} 
        onClose={handlePasswordModalClose}
        maxWidth="xs"
        fullWidth
      >
        <DialogTitle>
          Download Data
          <IconButton
            aria-label="close"
            onClick={handlePasswordModalClose}
            sx={{
              position: 'absolute',
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <Box sx={{ mt: 2, mb: 2 }}>
            <TextField
              fullWidth
              label="Password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              variant="outlined"
              sx={{ mb: 3 }}
            />
            <FormControl fullWidth>
              <InputLabel>Format</InputLabel>
              <Select
                value={downloadFormat}
                onChange={(e) => setDownloadFormat(e.target.value)}
                label="Format"
              >
                <MenuItem value="excel">Excel</MenuItem>
                <MenuItem value="pdf">PDF</MenuItem>
              </Select>
            </FormControl>
          </Box>
        </DialogContent>
        <DialogActions sx={{ p: 2 }}>
          <Button onClick={handlePasswordModalClose} color="inherit">
            Cancel
          </Button>
          <Button 
            onClick={handleDownloadConfirm} 
            variant="contained" 
            color="primary"
            disabled={!password}
          >
            Download
          </Button>
        </DialogActions>
      </Dialog>
              {/* Final Submit Button */}
              <Box display="flex" justifyContent="center" mt={4}>
                <Button
                  variant="contained"
                  color="primary"
                  size="large"
                  sx={{ 
                    px: 6, 
                    py: 1.5, 
                    fontSize: '1.1rem',
                    backgroundColor: '#1976d2',
                    '&:hover': {
                      backgroundColor: '#1565c0',
                    }
                  }}
                  onClick={handleSubmit}
                >
                  Submit All Tests
                </Button>
              </Box>
            </>
          )}
        </Paper>
      </Container>
    </Box>
  );
};

export default PrenatalTest; 